import { AnnotationIcon, GlobeAltIcon, LightningBoltIcon, CurrencyDollarIcon } from '@heroicons/react/outline'

const features = [
  {
    name: 'Upload your NFTS',
    description:
      'Upload you art on our digital marketplace easily. And explore tens of NFTs freely',
    icon: GlobeAltIcon,
  },
  {
    name: 'Custom page',
    description:
      'Get your own specific page for all your owned NFTs. You can view and add new NFTs.',
    icon: AnnotationIcon,
  },
  {
    name: 'No hidden fees',
    description:
      "We don't charge any amout of money from our users. We are as transparent as possible.",
    icon: CurrencyDollarIcon,
  },
  {
    name: 'Transfers are instant',
    description:
      'With the click of a button, you can transfer your digital assets to another user. It is as easy and fast as that.',
    icon: LightningBoltIcon,
  },
]

const About = () => {
  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">Own NFT</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            A better place to sell and buy digital assets
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            We help you to own your digital assets. Sell and buy them with ease. And make your own NFTs.
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                    <feature.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{feature.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}


export default About